export enum OrderItemEditorEnum {
  GroupMembership,
  Membership,
  Product,
  Concierge,
  Charter,
  FlightPass,
  EmptyLeg
}
